"use strict";
/**
 * Kalshi Market Fetcher
 * Handles fetching market data from Kalshi API
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchKalshiEvents = fetchKalshiEvents;
exports.fetchMoreKalshiMarkets = fetchMoreKalshiMarkets;
exports.fetchKalshiEventMarkets = fetchKalshiEventMarkets;
const state_1 = require("../state");
const api_1 = require("../api");
const cache_1 = require("./cache");
const converters_1 = require("./converters");
/**
 * Fetch events from Kalshi API
 */
async function fetchKalshiEvents(category) {
    try {
        console.log(`Fetching events from Kalshi API for ${category}...`);
        // Nested markets are required here (and only here): the display event's
        // scheduledDate — which drives the list sort — is derived from the
        // earliest nested market expiration. The server now honours this flag,
        // so callers that leave it off get a genuinely slim event list.
        const response = await (0, api_1.getEvents)(200, category, undefined, true);
        // Store events in cache
        (0, cache_1.setKalshiEventCache)(response.events);
        // Convert events to markets (for legacy support)
        const markets = response.events.map(converters_1.convertEventToMarket);
        (0, cache_1.setKalshiMarketCache)(markets);
        // Convert to DisplayEvent format
        const displayEvents = response.events.map(converters_1.kalshiEventToDisplayEvent);
        // Sort by scheduledDate ascending (soonest first)
        (0, converters_1.sortDisplayEventsByDate)(displayEvents);
        console.log(`Fetched ${response.events.length} Kalshi events, converted to ${displayEvents.length} display events`);
        return displayEvents;
    }
    catch (error) {
        const errorMessage = error instanceof api_1.ApiRequestError
            ? `Failed to fetch markets: ${error.message}`
            : "Failed to fetch markets. Please check your API credentials.";
        (0, state_1.updateState)({
            isLoadingMarkets: false,
            errorMessage,
        });
        throw error;
    }
}
/**
 * Fetch additional pages of Kalshi markets
 */
async function fetchMoreKalshiMarkets(cursor) {
    try {
        (0, state_1.updateState)({
            isLoadingMarkets: true,
            errorMessage: null,
        });
        const response = await (0, api_1.getEvents)(100, (0, cache_1.getCurrentCategory)(), cursor);
        // Convert events to markets
        const markets = response.events.map(converters_1.convertEventToMarket);
        // Append to cache
        (0, cache_1.appendKalshiMarketCache)(markets);
        (0, state_1.updateState)({ isLoadingMarkets: false });
        return markets;
    }
    catch (error) {
        console.error("Failed to fetch more markets:", error);
        (0, state_1.updateState)({
            isLoadingMarkets: false,
            errorMessage: "Failed to load more markets",
        });
        throw error;
    }
}
/**
 * Fetch all markets for a Kalshi event
 */
async function fetchKalshiEventMarkets(eventTicker) {
    console.log(`Fetching all markets for Kalshi event: ${eventTicker}...`);
    const eventDetail = await (0, api_1.getMarketsByEvent)(eventTicker);
    // Get all markets from response
    const allMarkets = eventDetail.markets || [];
    if (allMarkets.length === 0) {
        throw new Error(`No markets found for event: ${eventTicker}`);
    }
    // Convert all markets to Market format
    const convertedMarkets = allMarkets.map((market) => (0, converters_1.convertEventMarketToMarket)(market, eventDetail.event));
    console.log(`Fetched ${convertedMarkets.length} markets for Kalshi event: ${eventTicker}`);
    return convertedMarkets;
}
